export default new Map<string, string>([
  ['1', 'benzina'],
  ['2', 'diesel'],
  ['3', 'gpl'],
  ['4', 'elettrica'],
  ['5', 'altro'],
  ['6', 'ibrida'],
  ['7', 'metano'],
]);
